function envFlag(value, defaultValue = false) {
  const normalized = String(value ?? '').trim().toLowerCase()
  if (!normalized) return defaultValue
  if (['false', '0', 'no', 'off'].includes(normalized)) return false
  if (['true', '1', 'yes', 'on'].includes(normalized)) return true
  return defaultValue
}

export const ENABLE_USER_BILLING = envFlag(process.env.REACT_APP_ENABLE_USER_BILLING, true)
export const ENABLE_BILLING_COUPONS = true
export const ENABLE_BILLING_POINTS = true
export const BILLING_PAYMENT_PROVIDER = String(process.env.REACT_APP_BILLING_PAYMENT_PROVIDER || '').trim()
export const BILLING_PAYMENT_CONFIRM_ENABLED = Boolean(BILLING_PAYMENT_PROVIDER)
